import React, { useState, useEffect } from "react";
import "./ProductSpecification.css";
import {
  Tabs,
  Tab,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ProductSpecification = ({ productData , url, hashmapSpecifications }) => {
  const [tabValue, setTabValue] = useState(0);
  const [expandedAccordions, setExpandedAccordions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (productData) {
      console.log("productData",productData)
      // console.log("features",productData?.specifications )
      setLoading(false);
    }
  }, [productData]);

  const features = productData?.features || {};
  const specifications = productData?.specifications || {};

  useEffect(() => {
    const firstKey = Object.keys(specifications)[0] || Object.keys(features)[0];
    if (firstKey) {
      setExpandedAccordions((prev) => ({ ...prev, [firstKey]: true }));
    }
  }, [specifications, features]);

  const handleChange = (event, newValue) => setTabValue(newValue);

  const toggleAccordion = (key) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderNestedGroups = (data, depth = 1) => {
    return Object.entries(data).map(([key, value]) => {
      if (key === "Cellular Specification") return null;

      if (value.is_group === 1) {
        return (
          <div key={key} className={`border-top-accordion ${depth > 1 ? "products-specs-accordion-child" : ""}`}>
            <Accordion
              expanded={expandedAccordions[key] || false}
              onChange={() => toggleAccordion(key)}
              className={`products-specs-accordion ${expandedAccordions[key] ? "opened" : "closed"}`}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="products-specs-accordion-icon" />}
                aria-controls={`${key}-content`}
                id={`${key}-header`}
                className="products-specs-accordion-content"
              >
                <Typography>{loading ? <Skeleton width={100} /> : value.specification_name || key}</Typography>
              </AccordionSummary>
              <AccordionDetails className="products-specs-accordion-details accordion-details-scrollable">
                {loading ? <Skeleton count={3} /> : renderNestedGroups(value, depth + 1)}
              </AccordionDetails>
            </Accordion>
          </div>
        );
      } else {
        return <SpecsTable key={key} data={{ [key]: value }} loading={loading} url={url} labels={productData.labels} hashmapSpecifications={hashmapSpecifications}/>;
      }
    });
  };

  return (
    <div className="ProductsSpecs specification">
      {(specifications && Object.keys(specifications).length > 0) ||
          (features && Object.keys(features).length > 0) ? (
            <>
            <div className="specification-title">
              {loading ? <Skeleton width={200} /> : "Product Specification"}
            </div>
            <Box className="ProductsSpecs-container no-shadow">
              <Tabs
                value={tabValue}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="product specifications tabs"
                className="no-shadow"
                TabIndicatorProps={{
                  style: { backgroundColor: "#239DAB" },
                }}
              >
                {
                  specifications && Object.keys(specifications).length > 0 && (
                    <Tab label="Technical Specifications" sx={{ "&.Mui-selected": { color: "#239DAB" } }} />
                  )
                }
                {
                  features && Object.keys(features).length > 0 && (
                    <Tab label="Features" sx={{ "&.Mui-selected": { color: "#239DAB" } }} />
                  )
                }
              </Tabs>

              <Box className="tab-content no-shadow">
                {loading ? (
                  <Skeleton height={200} />
                ) : (
                  <>
                    {tabValue === 0 && <div>{renderNestedGroups(specifications, 1)}</div>}
                    {tabValue === 1 && <div>{renderNestedGroups(features, 1)}</div>}
                  </>
                )}
              </Box>
            </Box>
            </>
          ):(
            <></>
          )}
      
    </div>
  );
};

// const SpecsTable = ({ data, loading, url }) => (
//   <table className="specs-table specification-table">
//     <tbody>
//       {Object.entries(data)
//         .filter(([_, detail]) => detail.is_group === 0)
//         .map(([key, detail], index) => (
//           <tr key={index}>
//             <th>{loading ? <Skeleton width={80} /> : detail.field_name}</th>
//             <td>
//               {loading ? (
//                 <Skeleton width={150} />
//               ) : Array.isArray(detail.value) ? (
//                 detail.value
//                   .map((val) =>
//                     typeof val === "object" && val !== null
//                       ? Object.entries(val)
//                           .map(([subKey, subVal]) =>
//                             Array.isArray(subVal) ? `${subKey}: ${subVal.join(", ")}` : `${subKey}: ${subVal}`
//                           )
//                           .join("; ")
//                       : val
//                   )
//                   .join(", ")
//               ) : typeof detail.value === "boolean" ? (
//                 detail.value ? "Yes" : "No"
//               ) : typeof detail.value === "object" && detail.value.min !== undefined && detail.value.max !== undefined ? (
//                 detail.has_context && detail.context
//                   ? detail.context.replace("{}", detail.value.min).replace("{}", detail.value.max)
//                   : `${detail.value.min} - ${detail.value.max}`
//               ) : typeof detail.value === "object" ? (
//                 Object.entries(detail.value)
//                   .map(([subKey, subVal]) => `${subKey}: ${subVal}`)
//                   .join("; ")
//               ) : typeof detail.value === "string" && detail.value.startsWith("/files/") ? ( 
//                 <img
//                   src={`${url}${detail.value}`} 
//                   alt={detail.field_name}
//                   style={{ maxWidth: "100px", maxHeight: "100px" }}
//                 />
//               ) : (
//                 detail.value
//               )}
//             </td>
//           </tr>
//         ))}
//     </tbody>
//   </table>
// );

const SpecsTable = ({ data, loading, url, labels, hashmapSpecifications }) => (
  <table className="specs-table specification-table">
    <tbody>
      {Object.entries(data)
        .filter(([_, detail]) => detail.is_group === 0)
        .map(([key, detail], index) => (
          <tr key={index}>
            <th>{loading ? <Skeleton width={80} /> : detail.field_name}</th>
            <td>
              {loading ? (
                <Skeleton width={150} />
              ) : detail.value === null ? (
                <div className="product-details-output">
                    No Info
                </div>
              ) : detail.field_name === 'Color' ? (
                // Handle Color field specifically
                Array.isArray(detail.value) ? (
                  detail.value.length > 0 ? 
                    detail.value.join(", ") : 
                    "No Info"
                ) : detail.value ? (
                  detail.value
                ) : (
                  "No Info"
                )
              ) : detail.field_type === "Link Multiselect" ? (
                typeof detail.value === "object" && !Array.isArray(detail.value) ? (
                  <div className="link-multiselect-group">
                    {Object.entries(detail.value).map(([parentKey, childKeys]) => (
                      <div key={parentKey} className="link-multiselect-item">
                        <span className="parent-key">
                          {labels[parentKey] || parentKey}
                        </span>
                        {': '}
                        <span className="child-values">
                          {Array.isArray(childKeys)
                            ? childKeys.length > 0
                              ? childKeys
                                  .map(childKey => labels[childKey] || childKey)
                                  .join(', ')
                              : "No Info"
                            : JSON.stringify(childKeys)}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : Array.isArray(detail.value) ? (
                  detail.value.map((id) => labels[id] || id).join(", ")
                ) : (
                  Object.entries(detail.value)
                    .flatMap(([parentKey, childValues]) => [
                      labels[parentKey],
                      ...(Array.isArray(childValues)
                        ? childValues.map(childKey => labels[childKey] || childKey)
                        : [])
                    ])
                    .filter(Boolean)
                    .join(", ")
                )
              ) : detail.field_type === "Link" ? (
                labels[detail.value] || detail.value
              ) : (detail.field_type === "Number Range" || detail.field_type === "Percent Range" || detail.field_type === "Float Range") && detail.value?.min !== undefined && detail.value?.max !== undefined ? (
                detail.has_context && detail.context ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: detail.context
                        .replace(
                          "{min}",
                          `${detail.value.min !== null && detail.value.min !== undefined ? detail.value.min : 'No Info'} <span class="small-uom">${hashmapSpecifications[key].uom_abbr && hashmapSpecifications[key].uom_abbr !== null ? hashmapSpecifications[key].uom_abbr : hashmapSpecifications[key].uom && hashmapSpecifications[key].uom !== null ? hashmapSpecifications[key].uom : ""}</span>`
                        )
                        .replace(
                          "{max}",
                          `${detail.value.max !== null && detail.value.max !== undefined ? detail.value.max : 'No Info'} <span class="small-uom">${detail.uom_abbr && detail.uom_abbr !== null ? detail.uom_abbr : detail.uom && detail.uom !== null ? detail.uom : ""}</span>`
                        ),
                    }}
                  />
                ) : (
                  <div className="min-max-nocontext">
                    <div className="min-max-nocontext-content">
                      {detail.value.min !== null && detail.value.min !== undefined ? detail.value.min : 'No Info'}
                      <div className="small-uom">{detail.uom_abbr && detail.uom_abbr !== null ? detail.uom_abbr : detail.uom && detail.uom !== null ? detail.uom : ""}</div>
                    </div>
                     ~
                     <div className="min-max-nocontext-content">
                      {detail.value.max !== null && detail.value.max !== undefined ? detail.value.max : 'No Info'}
                      <div className="small-uom">{detail.uom_abbr && detail.uom_abbr !== null ? detail.uom_abbr : detail.uom && detail.uom !== null ? detail.uom : ""}</div>
                     </div>
                   
                  </div>
                )
              ) : Array.isArray(detail.value) ? (
                detail.value.map((val, index) =>
                  typeof val === "object" && val !== null ? (
                    Object.entries(val).map(([subKey, subVal]) => (
                      <span key={`${index}-${subKey}`}>
                        {subKey}: {Array.isArray(subVal) ? subVal.join(", ") : subVal}
                        {detail.uom && <div className="small-uom">{detail.uom}</div>}
                      </span>
                    ))
                  ) : (
                    <span key={index}>
                      {val}
                      {detail.uom && <div className="small-uom">{detail.uom}</div>}
                    </span>
                  )
                )
              ) :  typeof detail.value === "boolean" ? (
                detail.value ? "Yes" : "No"
              ) 
              :typeof detail.value === "object" && detail.value !== null ? (() => {
                let _context = hashmapSpecifications[key].context;
              
                Object.entries(detail.value).forEach(([subKey, subVal]) => {
                  const uom =
                    hashmapSpecifications[key].children[subKey]?.uom_abbr ||
                    hashmapSpecifications[key].children[subKey]?.uom ||
                    "";
              
                  _context = _context.replace(
                    new RegExp(`{${subKey}}`, "g"),
                    `${subVal !== null && subVal !== undefined ? subVal : "No Info"} <span class='small-uom'>${uom}</span>`
                  );
                });
              
                // Find remaining {key} placeholders
                _context = _context.replace(/{([^}]+)}/g, (match, missingKey) => {
                  const uom =
                    hashmapSpecifications[key].children[missingKey]?.uom_abbr ||
                    hashmapSpecifications[key].children[missingKey]?.uom ||
                    "";
              
                  return `No Info <span class='small-uom'>${uom}</span>`;
                });
              
                return (
                  <span key={key} className="children-details" dangerouslySetInnerHTML={{ __html: _context }} />
                );
              })() :  typeof detail.value === "string" && detail.value.startsWith("/files/") ? (
                <img
                  src={`${url}${detail.value}`}
                  alt={detail.field_name}
                  style={{ maxWidth: "100px", maxHeight: "100px" }}
                />
              ) : (
                <div className="product-details-output">
                {(() => {
                  if (detail.context) {
                    let contextValue = hashmapSpecifications[key].context;
                    const uomElement = hashmapSpecifications[key].uom_abbr ? (
                      <span className="small-uom">{hashmapSpecifications[key].uom_abbr}</span>
                    ) : hashmapSpecifications[key].uom ? (
                      <span className="small-uom">{hashmapSpecifications[key].uom}</span>
                    ) : null;
              
                    const parts = contextValue.split(`{${hashmapSpecifications[key].specification_name}}`);
                    
                    return (
                      <>
                        {parts[0]}
                        {detail.value} {uomElement}
                        {parts[1]}
                      </>
                    );
                  } else {
                    return (
                      <>
                        {detail.value}{" "}
                        {hashmapSpecifications[key].uom_abbr ? (
                          <span className="small-uom">{hashmapSpecifications[key].uom_abbr}</span>
                        ) : hashmapSpecifications[key].uom ? (
                          <span className="small-uom">{hashmapSpecifications[key].uom}</span>
                        ) : null}
                      </>
                    );
                  }
                })()}
              </div>              
              )}
            </td>
          </tr>
        ))}
    </tbody>
  </table>
);






// const SpecsTable = ({ data, loading, url }) => (
//   <table className="specs-table specification-table">
//     <tbody>
//       {Object.entries(data)
//         .filter(([_, detail]) => detail.is_group === 0)
//         .map(([key, detail], index) => (
//           <tr key={index}>
//             <th>{loading ? <Skeleton width={80} /> : detail.field_name}</th>
//             <td>
//               {loading ? (
//                 <Skeleton width={150} />
//               ) : Array.isArray(detail.value) ? (
//                 // Handle array values
//                 detail.value
//                   .map((val) =>
//                     typeof val === "object" && val !== null
//                       ? Object.entries(val)
//                           .map(([subKey, subVal]) =>
//                             Array.isArray(subVal) ? `${subKey}: ${subVal.join(", ")}` : `${subKey}: ${subVal}`
//                           )
//                           .join("; ")
//                       : val
//                   )
//                   .join(", ")
//               ) : typeof detail.value === "boolean" ? (
//                 // Handle boolean values
//                 detail.value ? "Yes" : "No"
//               ) : typeof detail.value === "object" && detail.value.min !== undefined && detail.value.max !== undefined ? (
//                 // Handle datetime range or time range
//                 key.toLowerCase().includes("datetime range") ? (
//                   // Format datetime range: min and max as date-time strings
//                   `${new Date(detail.value.min).toLocaleString()} - ${new Date(detail.value.max).toLocaleString()}`
//                 ) : key.toLowerCase().includes("time range") || key.toLowerCase().includes("time") ? (
//                   // Format time range: min and max as time strings
//                   `${new Date(`1970-01-01T${detail.value.min}Z`).toLocaleTimeString()} - ${new Date(`1970-01-01T${detail.value.max}Z`).toLocaleTimeString()}`
//                 ) : detail.context && detail.has_context ? (
//                   // Handle context-based values (like placeholders in the context)
//                   detail.context.replace("{}", detail.value.min).replace("{}", detail.value.max)
//                 ) : (
//                   // Default range formatting
//                   `${detail.value.min} - ${detail.value.max}`
//                 )
//               ) : typeof detail.value === "number" && key.toLowerCase().includes("time") ? (
//                 // Handle time value (assumes Unix timestamp)
//                 new Date(detail.value * 1000).toLocaleTimeString()
//               ) : typeof detail.value === "number" && key.toLowerCase().includes("datetime") ? (
//                 // Handle datetime value (assumes Unix timestamp)
//                 new Date(detail.value * 1000).toLocaleString()
//               ) : typeof detail.value === "object" ? (
//                 // Handle nested object values
//                 Object.entries(detail.value)
//                   .map(([subKey, subVal]) => `${subKey}: ${subVal}`)
//                   .join("; ")
//               ) : typeof detail.value === "string" && detail.value.startsWith("/files/") ? (
//                 // Handle file URLs (display images)
//                 <img
//                   src={`${url}${detail.value}`}
//                   alt={detail.field_name}
//                   style={{ maxWidth: "100px", maxHeight: "100px" }}
//                 />
//               ) : (
//                 // Default display for other values
//                 detail.value
//               )}
//             </td>
//           </tr>
//         ))}
//     </tbody>
//   </table>
// );





// const SpecsTable = ({ data, loading, url }) => (
//   <table className="specs-table specification-table">
//     <tbody>
//       {Object.entries(data)
//         .filter(([_, detail]) => detail.is_group === 0)
//         .map(([key, detail], index) => (
//           <tr key={index}>
//             <th>{loading ? <Skeleton width={80} /> : detail.field_name}</th>
//             <td>
//               {loading ? (
//                 <Skeleton width={150} />
//               ) : Array.isArray(detail.value) ? (
//                 // معالجة القيم التي تكون مصفوفة
//                 detail.value
//                   .map((val) =>
//                     typeof val === "object" && val !== null
//                       ? Object.entries(val)
//                           .map(([subKey, subVal]) =>
//                             Array.isArray(subVal) ? `${subKey}: ${subVal.join(", ")}` : `${subKey}: ${subVal}`
//                           )
//                           .join("; ")
//                       : val
//                   )
//                   .join(", ")
//               ) : typeof detail.value === "boolean" ? (
//                 // معالجة القيم المنطقية
//                 detail.value ? "Yes" : "No"
//               ) : typeof detail.value === "object" && detail.value.min && detail.value.max ? (
//                 // معالجة النطاقات
//                 key.toLowerCase().includes("datetime range") || detail.field_type === "DateTime Range" ? (
//                   `${new Date(detail.value.min).toLocaleString()} - ${new Date(detail.value.max).toLocaleString()}`
//                 ) : key.toLowerCase().includes("time range") || detail.field_type === "Time Range" ? (
//                   `${new Date(`1970-01-01T${detail.value.min}Z`).toLocaleTimeString()} - ${new Date(`1970-01-01T${detail.value.max}Z`).toLocaleTimeString()}`
//                 ) : (
//                   `${detail.value.min} - ${detail.value.max}`
//                 )
//               ) : typeof detail.value === "string" && key.toLowerCase().includes("datetime") ? (
//                 // معالجة التاريخ والوقت
//                 `${new Date(detail.value).toLocaleString()}`
//               ) : typeof detail.value === "string" && key.toLowerCase().includes("time") ? (
//                 // معالجة الوقت فقط
//                 `${new Date(`1970-01-01T${detail.value}Z`).toLocaleTimeString()}`
//               ) : typeof detail.value === "object" ? (
//                 // معالجة الكائنات العامة
//                 Object.entries(detail.value)
//                   .map(([subKey, subVal]) => `${subKey}: ${subVal}`)
//                   .join("; ")
//               ) : typeof detail.value === "string" && detail.value.startsWith("/files/") ? (
//                 // معالجة الصور
//                 <img
//                   src={`${url}${detail.value}`}
//                   alt={detail.field_name}
//                   style={{ maxWidth: "100px", maxHeight: "100px" }}
//                 />
//               ) : (
//                 // القيم الافتراضية الأخرى
//                 detail.value
//               )}
//             </td>
//           </tr>
//         ))}
//     </tbody>
//   </table>
// );






export default ProductSpecification;
